import apiClient from './client';

export const interactionsApi = {
  uploadFiles: async (projectId, formData) => {
    const response = await apiClient.post(`/rds/projects/${projectId}/interactions/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  pasteText: async (projectId, payload) => {
    const response = await apiClient.post(`/rds/projects/${projectId}/interactions/paste`, payload);
    return response.data;
  },

  getInteractions: async (projectId) => {
    const response = await apiClient.get(`/rds/projects/${projectId}/interactions`);
    return response.data;
  },

  getInteraction: async (projectId, interactionId) => {
    const response = await apiClient.get(`/rds/projects/${projectId}/interactions/${interactionId}`);
    return response.data;
  },

  // The original upload, a PDF of a DOCX, or the extracted text — the
  // backend picks; contentType tells the viewer which one it got.
  getInteractionContent: async (projectId, interactionId) => {
    const response = await apiClient.get(
      `/rds/projects/${projectId}/interactions/${interactionId}/content`,
      { responseType: 'blob' },
    );
    return { blob: response.data, contentType: response.headers['content-type'] || '' };
  },

  deleteInteraction: async (projectId, interactionId) => {
    await apiClient.delete(`/rds/projects/${projectId}/interactions/${interactionId}`);
  },

  summarizeInteraction: async (projectId, interactionId) => {
    const response = await apiClient.post(`/rds/projects/${projectId}/interactions/${interactionId}/summarize`);
    return response.data;
  },
};
